<template>
  <div>
    <b-modal
      ref="replace-product"
      id="replace-product"
      size="xl"
      hide-footer
      hide-header
      centered
      @hide="hideReplaceProductModal"
    >
      <b-row>
        <b-col md="8">
          <h6 class="mb-3 fw-normal">
            Replace Product
          </h6>
        </b-col>
        <b-col md="4">
          <b-input-group size="md" class="box-shadow">
            <b-form-input
              v-model="barcode"
              placeholder="Scan or enter barcode..."
              v-on:keyup.enter="
                getProductDetails($event.target.value),
                  (isHide = false),
                  (searchResponseList = []),
                  (barcode = '')
              "
              @keyup.esc="cancelSearch"
              class="search"
              @keyup="productSearch"
              autocomplete="off"
              v-shortkey.focus="['ctrl', 's']"
              autofocus
              ref="search"
            />
            <b-input-group-text slot="append" class="search-icon">
              <font-awesome-icon :icon="['fas', 'search']" />
            </b-input-group-text>
          </b-input-group>
          <!-- Auto Suggestion -->
          <transition name="slide">
            <div class="product-search" v-show="isHide">
              <div class="box-shadow">
                <ul id="product-list" v-if="searchResponseList.length !== 0">
                  <li
                    v-for="item in searchResponseList"
                    :key="item.index"
                    class="get-product"
                    @click="getProductDetails(item)"
                  >
                    <b-row>
                      <b-col class="w-75">
                        <h6 v-text="item.name" />
                      </b-col>
                      <b-col class="w-25">
                        <span v-text="currencySymbol + item.mrp" />
                      </b-col>
                    </b-row>
                  </li>
                </ul>
                <div
                  class="row align-items-center notification"
                  style="height:100%"
                  v-else
                >
                  <h6 class="text-center w-100">No product found.</h6>
                </div>
              </div>
            </div>
          </transition>
        </b-col>
        <b-col md="12" class="mt-2">
          <p class="fs-12 mb-4">
            Scan or search for a product to replace the current product. You
            cannot undo this action.
          </p>
          <p class="mt-3 mb-2 text-primary">Current Product</p>
        </b-col>
      </b-row>

      <b-row class="mb-3">
        <b-col>
          <label class="pl-0">Barcode</label>
          <p v-text="currentProduct.barcode" />
        </b-col>
        <b-col cols="2">
          <label class="pl-0">Product</label>
          <p v-text="currentProduct.name" />
        </b-col>
        <b-col>
          <label class="pl-0">Unit Price</label>
          <p v-text="currencySymbol + formatAmount(currentProduct.mrp)" />
        </b-col>
        <b-col>
          <label class="pl-0">Total Discount</label>
          <p
            v-text="
              currencySymbol + formatAmount(currentProduct.total_discount)
            "
          />
        </b-col>
        <b-col>
          <label class="pl-0">Total Taxes</label>
          <p v-text="currencySymbol + formatAmount(currentProduct.tax)" />
        </b-col>
        <b-col>
          <label class="pl-0">Total Amount</label>
          <p v-text="currencySymbol + formatAmount(currentProduct.total)" />
        </b-col>
        <b-col>
          <label class="pl-0">Ordered Units</label>
          <p v-text="currentProduct.qty" />
        </b-col>
        <b-col>
          <label class="pl-0">Units Available</label>
          <p
            :class="[
              currentProduct.available_qty < 0 ? 'text-danger' : 'text-success',
            ]"
            v-text="currentProduct.available_qty"
          ></p>
        </b-col>
        <b-col>
          &nbsp;
        </b-col>
      </b-row>

      <b-link class="mt-3 mb-2 text-blue">Replacement Product</b-link>
      <p
        class="mt-3 text-muted"
        v-if="Object.keys(replaceProduct).length === 0"
      >
        Scan a product to view its information
      </p>

      <b-row class="mb-3 mt-2" v-if="Object.keys(replaceProduct).length !== 0">
        <b-col>
          <label class="pl-0">Barcode</label>
          <p v-text="replaceProduct.barcode" />
        </b-col>
        <b-col cols="2">
          <label class="pl-0">Product</label>
          <p v-text="replaceProduct.item_name" />
        </b-col>
        <b-col>
          <label class="pl-0">Unit Price</label>
          <p v-text="currencySymbol + formatAmount(replaceProduct.unit_mrp)" />
        </b-col>
        <b-col>
          <label class="pl-0">Total Discount</label>
          <p
            v-text="
              currencySymbol + formatAmount(replaceProduct.total_discount)
            "
          />
        </b-col>
        <b-col>
          <label class="pl-0">Total Taxes</label>
          <p v-text="currencySymbol + formatAmount(replaceProduct.tax)" />
        </b-col>
        <b-col>
          <label class="pl-0">Total Amount</label>
          <p v-text="currencySymbol + formatAmount(replaceProduct.total)" />
        </b-col>
        <b-col>
          <label class="pl-0">Ordered Units</label>
          <p
            v-text="parseFloat(replaceProduct.qty).toFixed(2)"
            v-if="replaceProduct.weight_flag"
          />
          <select
            class="custom-select custom-select-sm fs-12"
            @change="updateQty($event.target.value)"
            v-if="!replaceProduct.weight_flag"
          >
            <option
              v-for="(nqty, index) in parseInt(replaceProduct.available_qty)"
              v-bind:key="index"
              v-text="nqty"
              :value="nqty"
              :selected="nqty == replaceProduct"
              :id="'order-replace-' + index"
            />
          </select>
        </b-col>
        <b-col>
          <label class="pl-0">Units Available</label>
          <p
            :class="[
              replaceProduct.available_qty < 0 ? 'text-danger' : 'text-success',
            ]"
            v-text="replaceProduct.available_qty"
          />
        </b-col>
        <b-col>
          &nbsp;
        </b-col>
      </b-row>

      <b-row class="mt-5">
        <b-col md="2" offset-md="8">
          <b-button
            block
            @click="$bvModal.hide('replace-product')"
            v-shortkey="['esc']"
            @shortkey="$bvModal.hide('replace-product')"
            :disabled="$loading"
            variant="outline-primary"
            >Dismiss
          </b-button>
        </b-col>
        <b-col md="2" class="pl-0">
          <b-button
            block
            :disabled="Object.keys(replaceProduct).length === 0 || $loading"
            @click="confirmReplaceProduct"
            variant="primary"
          >
            <span v-if="!$loading">Replace</span>
            <b-spinner small v-else />
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
    <select-batch-modal
      :open="openBatchSelectModal"
      :options="batchList"
      :barcode="selectedBarcode"
      :batch="''"
      @close-batch-modal="openBatchSelectModal = false"
      @update-batch="updateBatch"
      :type="invType"
    />
  </div>
</template>

<script>
import axios from "axios";
import { STOCK_UNAVAILABLE, REPLACE_SUCCESS, SAME_BARCODE } from "../message";
import { mapState } from "vuex";
import SelectBatchModal from "./SelectBatchModal";

export default {
  name: "order-replace-modal",
  props: ["open", "currentProduct"],
  components: { SelectBatchModal },
  data() {
    return {
      replaceProduct: {},
      // currentProduct: {},
      isHide: false,
      searchResponseList: [],
      barcode: "",
      userDetails: {
        comm_trans: "B2C",
        cust_gstin: null,
      },
      invType: "",
      replaceProductBatch: {},
      openBatchSelectModal: false,
      batchList: [],
      selectedBarcode: "",
    };
  },
  watch: {
    open() {
      if (this.open) {
        // this.currentProduct = this.pdata;
        this.barcode = "";
        this.$refs["replace-product"].show();
      }
    },
  },
  computed: {
    ...mapState({
      state: (state) => state,
    }),
  },
  methods: {
    hideReplaceProductModal() {
      this.replaceProduct = {};
      // this.currentProduct = {};
      this.isHide = false;
      this.searchResponseList = [];
      this.barcode = "";
      this.$emit("close-replace");
    },
    getProductDetails(val, from = "") {
      if (val == "") return;
      this.$loading = true;
      let postData = Object.assign(
        {
          barcode: val.barcode == undefined ? val : val.barcode,
          url: "/oms/get-product-details",
          qty:
            from == "updateQty"
              ? this.replaceProduct.qty
              : this.currentProduct.qty,
          comm_trans: this.userDetails.comm_trans,
          cust_gstin: this.userDetails.cust_gstin,
          type: from == "updateQty" ? "update" : "add",
          weight: val.weight_flag,
          from_screen: "pack",
        },
        this.essentialsData
      );
      axios
        .post(postData.url, postData)
        .then((res) => {
          if (res.data.status == "fail") {
            this.$store.commit("notifications/showAlert", {
              message: res.data.data,
              type: "danger",
            });
            this.$showAlert = true;
          } else {
            if (
              postData.type == "add" &&
              this.currentProduct.original_barcode == res.data.data.barcode
            ) {
              this.$store.commit("notifications/showAlert", {
                message: SAME_BARCODE,
                type: "danger",
              });
              this.$showAlert = true;
              return;
            }
            if (
              (postData.type == "add" && res.data.data.batch.length > 0) ||
              (postData.type == "add" && res.data.data.serial.length > 0)
            ) {
              this.invType =
                res.data.data.batch.length > 0 ? "batch" : "serial";
              this.openBatchSelectModal = true;
              this.batchList =
                this.invType == "batch"
                  ? res.data.data.batch
                  : res.data.data.serial;
              this.selectedBarcode = res.data.data.barcode;
              this.replaceProductBatch = res.data.data;
              return;
            }
            if (res.data.data.is_available) this.replaceProduct = res.data.data;
            else {
              this.$store.commit("notifications/showAlert", {
                message: STOCK_UNAVAILABLE,
                type: "danger",
              });
              this.$showAlert = true;
            }
          }
          this.$loading = false;
          this.isHide = false;
          this.barcode = "";
          this.searchResponseList = [];
        })
        .catch(() => (this.$loading = false));
    },
    productSearch: _.debounce(function(event) {
      this.isHide = false;
      if (this.barcode == "") return;
      let data = Object.assign(
        {
          search_term: this.barcode,
          url: "/product-search",
        },
        this.essentialsData
      );

      if (typeof this._source != typeof undefined) {
        this._source.cancel("Operation canceled due to new request.");
      }

      this._source = axios.CancelToken.source();

      axios
        .post(data.url, data, { cancelToken: this._source.token })
        .then((response) => {
          this.isHide = true;
          this.searchResponseList = response.data.data.data;
        })
        .catch(() => (this.$loading = false));
    }, 200),
    cancelSearch() {
      this.barcode = "";
    },
    async confirmReplaceProduct() {
      this.$loading = true;

      let list = await this.state.stock.orderProductList.filter((item) => {
        let replacedBarcode = _.cloneDeep(this.currentProduct.barcode);
        if (this.currentProduct.barcode == item.barcode) {
          item.barcode = this.replaceProduct.barcode;
          item.qty = this.replaceProduct.qty;
          item.name = this.replaceProduct.item_name;
          item.mrp = this.replaceProduct.unit_mrp;
          item.total_discount = this.replaceProduct.total_discount;
          item.tax = this.replaceProduct.tax;
          item.total = this.replaceProduct.total;
          item.stotal =
            parseFloat(this.replaceProduct.total) /
            parseFloat(this.replaceProduct.qty);
          item.subtotal = parseFloat(this.replaceProduct.unit_mrp) * parseFloat(this.replaceProduct.qty);
          item.ssubtotal =
            parseFloat(this.replaceProduct.unit_mrp) /
            parseFloat(this.replaceProduct.qty);
          item.id = this.replaceProduct.id;
          item.message = this.replaceProduct.message;
          item.is_sellable = this.replaceProduct.is_sellable;
          item.is_available = this.replaceProduct.is_available;
          item.available_qty = this.replaceProduct.available_qty;
          item.stock_point_name = this.replaceProduct.stock_point_name;
          item.weight_flag = this.replaceProduct.weight_flag;
          item.selected_batch =
            this.replaceProduct.batch_id != 0
              ? this.replaceProduct.batch_id
              : this.replaceProduct.serial_id;
          item.batch_list =
            this.replaceProduct.batch.length > 0
              ? this.replaceProduct.batch
              : this.replaceProduct.serial;
          item.replaced = replacedBarcode;
          item.invType =
            this.replaceProduct.batch_id != 0
              ? "batch"
              : this.replaceProduct.serial_id != 0
              ? "serial"
              : "";
        }
        return item;
      });
      this.$store.commit("stock/setOrderProducts", list);
      this.$loading = false;
      this.$refs["replace-product"].hide();
      this.$store.commit("notifications/showAlert", {
        message: REPLACE_SUCCESS,
        type: "success",
      });
      this.$showAlert = true;
    },
    updateQty(value) {
      this.replaceProduct.qty = value;
      this.getProductDetails(this.replaceProduct, "updateQty");
    },
    updateBatch(bdata) {
      let data = Object.assign(
        {
          url: "/oms/get-product-details-by-inventory",
          batch_id: this.invType == "batch" ? bdata.batch_data : "",
          serial_id: this.invType == "serial" ? bdata.batch_data : "",
          barcode: this.selectedBarcode,
          type: "add",
          comm_trans: this.userDetails.comm_trans,
          cust_gstin: this.userDetails.cust_gstin,
          qty: this.currentProduct.qty,
          weight: this.replaceProductBatch.weight_flag,
        },
        this.essentialsData
      );
      axios.post(data.url, data).then((res) => {
        if (res.data.status == "success") {
          this.openBatchSelectModal = false;
          this.barcode = "";
          this.invType = "";
          this.replaceProductBatch = {};
          this.searchResponseList = [];
          this.isHide = false;
          this.replaceProduct = res.data.data;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.product-search {
  background-color: #fff;
  position: absolute;
  width: 92%;
  z-index: 9;
  left: 15px;
  ul {
    padding: 0;
    // top: -350px;
    height: auto;
    max-height: 350px;
    // border-radius: 0px;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    overflow-y: auto;
    @include custom-scrollbar();
    margin-bottom: 0px;
  }
  li {
    width: 100%;
    list-style-type: none;
    padding: 5px 15px;
    border-bottom: 1px #f0f0f0 solid;
    &:hover {
      background-color: #c0c0c0;
      color: #fff;
      cursor: pointer;
    }
    &:last-child {
      border-bottom: transparent !important;
    }
    p {
      font-weight: 300;
      font-size: 0.625rem;
    }
    h6 {
      font-weight: 400;
      font-size: 0.825rem;
      margin: 0px;
      text-align: left;
    }
    .row {
      display: table;
      width: 100%;
      .col {
        display: table-cell;
        vertical-align: middle;
        color: #000;
      }
    }
  }
}
</style>
